<p>application-response-from-search works!</p>
